module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Import from CSV":"Импортировать из CSV"}}')
  delete Component.options._Ctor
}
